module.exports = __webpack_public_path__ + "img/googleReviews.126e06a2.png";